__turbopack_context__.v({
  "amount": "Price-module-scss-module__WBeteG__amount",
  "discount": "Price-module-scss-module__WBeteG__discount",
  "is-hidden": "Price-module-scss-module__WBeteG__is-hidden",
  "old-price": "Price-module-scss-module__WBeteG__old-price",
  "price": "Price-module-scss-module__WBeteG__price",
  "timer": "Price-module-scss-module__WBeteG__timer",
});
